import { LOGIN_SUCCESS, SET_CONFIGURATION_LIST } from "../../common/actionTypes";
import { APPLICATION_LOCAL_STORAGE } from "../../common/constants/constants";
import { getEnv } from "../../enviroment";
import { fetch_retry_post, fetch_retry_get } from "./ApiManager";
const { base } = getEnv();

const userlogin = (payload) => async (dispatch) => {
  try {
    let response = await fetch_retry_post(`${base}/login`, payload);
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      localStorage.setItem("authToken", resp.data.authToken);
      localStorage.setItem(APPLICATION_LOCAL_STORAGE.REFRESH_TOKEN,resp.data.refreshToken);
      dispatch({
        type: LOGIN_SUCCESS,
        payload: resp.data,
      });
      return { success: true, data:resp };
    } else {
      return { success: false, data: resp.data };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};
// logout user
const userLogout = () => async (dispatch) => {
  try {
    let response = await fetch_retry_get(`${base}/user/logout`);
    if (response.status === 200 || response.status === 201) {
      return { success: true };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};


export const Auth = {
  userlogin,
  userLogout,
};
